/**
 * currentAdmin.js — helper to read the currently logged-in admin's identity
 * from the JWT stored in localStorage.
 *
 * The JWT is verified server-side on every API call; here we only decode the
 * payload to display the user's email in the UI. If the token is missing,
 * malformed, or expired, returns null.
 */

const TOKEN_KEY = "cc_admin_token";

function _b64UrlDecode(s) {
  s = s.replace(/-/g, "+").replace(/_/g, "/");
  const pad = s.length % 4;
  if (pad) s += "=".repeat(4 - pad);
  try {
    return atob(s);
  } catch {
    return null;
  }
}

export function getAdminToken() {
  try {
    return localStorage.getItem(TOKEN_KEY) || null;
  } catch {
    return null;
  }
}

export function getCurrentAdmin() {
  const token = getAdminToken();
  if (!token) return null;
  const parts = token.split(".");
  if (parts.length !== 3) return null;
  const raw = _b64UrlDecode(parts[1]);
  if (!raw) return null;
  let payload;
  try {
    payload = JSON.parse(raw);
  } catch {
    return null;
  }
  // Expiry check (soft: server enforces hard check)
  if (payload.exp && payload.exp * 1000 <= Date.now()) return null;
  return {
    id: payload.sub || "",
    email: payload.email || "",
    exp: payload.exp || 0,
  };
}

export function getCurrentAdminEmail() {
  return getCurrentAdmin()?.email || "";
}

/** Nice-looking initials from an email like "f.gonzalez@unioncasa.org" → "FG". */
export function initialsFromEmail(email) {
  if (!email) return "?";
  const local = email.split("@")[0] || "";
  const parts = local.split(/[._-]/).filter(Boolean);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[1][0]).toUpperCase();
  }
  return local.slice(0, 2).toUpperCase();
}
